if (!Array.prototype.toSorted) {
  Array.prototype.toSorted = function (compareFunction) {
    return this.slice().sort(compareFunction);
  };
}
